import React, { useState, useContext, useEffect } from "react";
import {
  RegisterWrapper,
  LoginInputWrapper,
  LoginInput,
  InputIcon,
  ForgetLink,
  SubmitBtn
} from "../UI/login.js";
import Logo from "../../assets/image/login-logo.png";
import { Formik, Form, Field } from "formik";
import { createFormInitial, createSendForm } from "../../utils/form";
import { loginSchema } from "../../configs/formSchema";
import { css } from "styled-components/macro";
import { LoginValidSchema } from "../../configs/validationSchemas";
import fetchModule from "../../utils/fetchingData";
import API from "./../../configs/API";
import { toast } from "react-toastify";
import lstool from "../../utils/localStorage";
import { DC } from "../../utils/general.js";
import { ModalContext } from "./../general/ModalContext";
// function Mod() {
//   return <h2>hello</h2>;
// }
function Login(props) {
  const [isLoading, setLoading] = useState(false);
  const submit = async val => {
    val = { ...val, mobilenumber: val.mobilenumber };
    setLoading(true);
    try {
      let response = await fetchModule.post(
        "",
        createSendForm({ type: API.login, ...val }, false, "multiPart")
      );
      if (typeof response === "object") {
        const {
          employmentid: id,
          name,
          family,
          accepttypenumber: AccessToImport
        } = response[0];
        lstool.set(undefined, id);
        lstool.set(
          "userData",
          JSON.stringify({ name: name + " " + family, AccessToImport })
        );
        props.history.replace("/");
      } else {
        toast.error(response);
        setLoading(false);
      }
    } catch (error) {
      toast.error("نام کاربری یا رمز عبور اشتباه است");
      setLoading(false);
    }
  };
  return (
    <Formik
      validationSchema={LoginValidSchema}
      onSubmit={submit}
      initialValues={createFormInitial(loginSchema)}
    >
      {props => {
        return (
          <RegisterWrapper as={Form}>
            <div>
              <img style={{ maxHeight: "200px" }} src={Logo}></img>
            </div>
            <div>
              {loginSchema.map(item => (
                <LoginInputWrapper key={item.name}>
                  <LoginInput
                    as={Field}
                    type={item.type}
                    name={item.name}
                    placeholder={item.title}
                    css={css`
                      height: 55px;
                    `}
                  ></LoginInput>
                  <InputIcon className={item.icon}></InputIcon>
                </LoginInputWrapper>
              ))}
              <ForgetLink
                css={css`
                  display: block;
                  color: var(--color2);
                `}
                to={"/forgetPassword  "}
              >
                فراموشی رمز عبور
              </ForgetLink>
            </div>
            <div>
              <SubmitBtn loading={isLoading} type="submit">
                ورود
              </SubmitBtn>
              <ForgetLink
                css={css`
                  display: block;
                  margin-top: 15px;
                  color: var(--color1);
                `}
                to={"/register"}
              >
                حساب کاربری نداری؟
              </ForgetLink>
            </div>
          </RegisterWrapper>
        );
      }}
    </Formik>
  );
}
export default Login;
